<div>

	<readonly-access [readonly]="!dialogDataService.canEdit()"></readonly-access>

	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
		[rows]="dialogDataService.dialogData()?.accEntrepreneurs ?? []"></grid-content>
</div>